<template>
    <ul class="nav avp-meta-navigation">
        <li class="nav-item">
            <a :href=shopUrl() target="_blank" rel="noopener" class="nav-link">{{ $t('footer.action.link_shop.text') }}
            </a>
        </li>
        <li class="nav-item">
            <a :href=imprintUrl() target="_blank" rel="noopener"
               class="nav-link">{{ $t('footer.action.link_imprint.text') }}
            </a>
        </li>
        <li class="nav-item">
            <a :href=tosUrl() target="_blank" rel="noopener"
               class="nav-link">{{ $t('footer.action.link_tos.text') }}
            </a>
        </li>
        <li class="nav-item">
            <a :href=privacyUrl() target="_blank" rel="noopener"
               class="nav-link">{{ $t('generic.data_protection') }}
            </a>
        </li>
        <li class="nav-item" v-if="isSupportedLocale">
            <LanguageSelect />
        </li>
    </ul>
</template>

<script>
    import LanguageSelect from '@/components/LanguageSelect';

    export default {
        name: 'CardFooter',
        components: {
            LanguageSelect
        },
        computed: {
            isSupportedLocale() {
                var isKurzInUrlaubInstance = location.hostname === 'einloesen.kurz-in-urlaub.de'
                    || location.search.indexOf('variant=kurzinurlaub') !== -1;
                return !isKurzInUrlaubInstance;
            }
        },
        methods: {
          shopUrl: function() { return this.$i18n.t( 'footer.action.link_shop.url' ); },
          imprintUrl: function() { return this.$i18n.t( 'footer.action.link_imprint.url' ); },
          tosUrl: function() { return this.$i18n.t( 'footer.action.link_tos.url' ); },
          privacyUrl: function() { return this.$i18n.t( 'footer.action.link_privacy.url' ); },
        },
        data: function () {
            return {
            };
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @use "@/styles/_variables";
    @use "sass:map";


    $linkColor: map.get(variables.$colors, 'link');

    .avp-meta-navigation {
        justify-content: center;

        .nav-link {
            padding: 0.5rem;
            text-decoration: underline;
            transition: color 0.5s ease;

            &:link {
                color: $linkColor;
            }

            &:active {
                color: lighten($linkColor, 50%);
            }

            &:visited {
                color: darken($linkColor, 10%);
            }

            &:hover {
                color: lighten($linkColor, 25%);
            }
        }
    }
</style>
